// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._toast-success_1dljs_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #43a047;
  box-shadow: 0 0 7px rgba(67, 160, 71, 0.5);
  color: #fff;
  text-align: center;
}

._toast-blue-dusk_pnidt_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background: linear-gradient(130deg, #4e51d8 0%, #626ed4 50%, #4e51d8 100%);
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
  color: #fff;
  text-align: center;
}

._toast-warning_ohu7r_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #f0ad4e;
  box-shadow: 0 0 7px rgba(240, 173, 78, 0.5);
  color: #fff;
  text-align: center;
}

._toast-info_v91zz_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #2196f3;
  box-shadow: 0 0 7px rgba(33, 150, 243, 0.5);
  color: #fff;
  text-align: center;
}

._toast-failure_1xuna_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #d32f2f;
  box-shadow: 0 0 7px rgba(211, 47, 47, 0.5);
  color: #fff;
  text-align: center;
}

._toast-dark_1uck5_1 {
  overflow: hidden;
  min-width: 200px;
  padding: 12px 22px;
  background: rgba(0, 0, 10, 0.8);
  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 40px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
  vertical-align: top;
  white-space: pre-line;
}

._toast-light_1t8t0_1 {
  overflow: hidden;
  min-width: 200px;
  padding: 12px 22px;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 40px;
  color: #000;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
  vertical-align: top;
  white-space: pre-line;
}

._toast-plain_11plr_1 {
  min-width: 200px;
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.2);
  color: #333;
  text-align: center;
}

._toast-dark-edge_z8drx_1 {
  overflow: hidden;
  min-width: 200px;
  padding: 12px 22px;
  background: rgba(0, 0, 10, 0.8);
  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
  vertical-align: top;
  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/toasts.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0EAA0E;EAC1E,sCAAsC;EACtC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;EAC9C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["._toast-success_1dljs_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background-color: #43a047;\n  box-shadow: 0 0 7px rgba(67, 160, 71, 0.5);\n  color: #fff;\n  text-align: center;\n}\n\n._toast-blue-dusk_pnidt_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background: linear-gradient(130deg, #4e51d8 0%, #626ed4 50%, #4e51d8 100%);\n  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);\n  color: #fff;\n  text-align: center;\n}\n\n._toast-warning_ohu7r_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background-color: #f0ad4e;\n  box-shadow: 0 0 7px rgba(240, 173, 78, 0.5);\n  color: #fff;\n  text-align: center;\n}\n\n._toast-info_v91zz_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background-color: #2196f3;\n  box-shadow: 0 0 7px rgba(33, 150, 243, 0.5);\n  color: #fff;\n  text-align: center;\n}\n\n._toast-failure_1xuna_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background-color: #d32f2f;\n  box-shadow: 0 0 7px rgba(211, 47, 47, 0.5);\n  color: #fff;\n  text-align: center;\n}\n\n._toast-dark_1uck5_1 {\n  overflow: hidden;\n  min-width: 200px;\n  padding: 12px 22px;\n  background: rgba(0, 0, 10, 0.8);\n  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);\n  border-radius: 40px;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n  vertical-align: top;\n  white-space: pre-line;\n}\n\n._toast-light_1t8t0_1 {\n  overflow: hidden;\n  min-width: 200px;\n  padding: 12px 22px;\n  background-color: rgba(255, 255, 255, 0.95);\n  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);\n  border-radius: 40px;\n  color: #000;\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n  vertical-align: top;\n  white-space: pre-line;\n}\n\n._toast-plain_11plr_1 {\n  min-width: 200px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background-color: #fff;\n  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.2);\n  color: #333;\n  text-align: center;\n}\n\n._toast-dark-edge_z8drx_1 {\n  overflow: hidden;\n  min-width: 200px;\n  padding: 12px 22px;\n  background: rgba(0, 0, 10, 0.8);\n  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n  vertical-align: top;\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
